// extracted by mini-css-extract-plugin
export default {"bar":"StatusBar_bar__wyt0i"};